import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UndoAvailability, UndoPreview, UndoResult, UndoRun } from '../../models';
import { TmsWebBaseService } from '../base';

/**
 * The Un-do routines API (Ross Un-do routines, D-20): preview where a record stands and how far back
 * it can go, then run the stopping point the user chose. The server checks the user's grant on every
 * call (D-22). Most screens should go through UndoDialogService rather than calling this directly.
 */
@Injectable({
  providedIn: 'root',
})
export class UndoService extends TmsWebBaseService {
  constructor() {
    super('Undo');
  }

  preview(kind: string, recordId: string): Observable<UndoPreview> {
    return this.httpService.get<UndoPreview>(`${this.apiUrl}/Preview/${kind}/${recordId}`);
  }

  run(model: UndoRun): Observable<UndoResult> {
    return this.httpService.post<UndoResult>(`${this.apiUrl}/Run`, model);
  }

  stockItemAvailability(stockItemId: string): Observable<UndoAvailability> {
    return this.httpService.get<UndoAvailability>(`${this.apiUrl}/StockItemAvailability/${stockItemId}`);
  }
}
